import { z } from 'zod';
import { ArgoConnectionKindEnum } from '../db';

export const ptl110PickLightConnectionConfigSchema = z.object({
    kind: z.literal(ArgoConnectionKindEnum.Ptl110PickLight),
    details: z.discriminatedUnion('kind', [
        z.object({
            // device path; i.e. COM3, /dev/...
            serialPort: z.string(),
            kind: z.literal('serial'),
        }),
        z.object({
            ip: z.string(),
            port: z.number(),
            kind: z.literal('eth'),
        }),
    ]),
});
export type Ptl110PickLightConnectionConfig = z.infer<typeof ptl110PickLightConnectionConfigSchema>;
